<tp-modal dialogTitle="Setup Authenticator App" [isBusy]="isSubmitting$ | async">
  <tp-mfa-setup [isSubmitting$]="isSubmitting$" [cancellable]="true" (mfaSuccess)="onSuccess()" (cancel)="close()"></tp-mfa-setup>
</tp-modal>
